import { render, staticRenderFns } from "./SupplyChainPreference.vue?vue&type=template&id=e5a5b00c&scoped=true"
import script from "./SupplyChainPreference.vue?vue&type=script&lang=js"
export * from "./SupplyChainPreference.vue?vue&type=script&lang=js"
import style0 from "./SupplyChainPreference.vue?vue&type=style&index=0&id=e5a5b00c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a5b00c",
  null
  
)

export default component.exports